import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <IndexSection />
        <AppSection />
        <RankingSection />
        <CarouselSection />
        <UpdatesSection />
        <MediaSection />
        <FAQSection />
        <FeaturesSection />
        <TopicsSection />
        <CardsSection />
        <CommentsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}